import { useMediaQuery } from 'react-responsive';

const DEFAULT_MAX_MOBILE_WIDTH = 480;

type UseMobileCheck = (maxWidthPx?: number) => boolean;

const useMobileCheck: UseMobileCheck = (maxWidthPx = DEFAULT_MAX_MOBILE_WIDTH) => {
  return useMediaQuery({ query: `(max-width: ${maxWidthPx}px)` });
};

export default useMobileCheck;
